<template>
  <div class="loader">
    <div class="loader__progress"></div>
  </div>
</template>

<script>
export default {
  name: 'loader',
};
</script>

<style lang="scss" scoped>
.loader {
  background: transparent;
  display: flex;
  flex: 1;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;

  &__progress {
    height: 4px;
    background: color('secondary');
    width: 100px;
    border-radius: 4px;
    animation: loading 2s ease-in-out infinite;
  }
}

@keyframes loading {
  0% {
    width: 0%;
    transform: translateX(0);
  }

  100% {
    width: 70%;
    transform: translateX(150%);
  }
}
</style>
